/* eslint-disable react/prop-types */
import React from 'react';
import {Route, Redirect, withRouter  } from 'react-router-dom';
import HomieContext from 'HomieContext';

class PrivateRoute extends React.Component {
  render() {
    let {currentUser} = this.context;

    let {
      location,
      component:Component,
      propsComponent,
      redirect,
      ...rest
    } = this.props;
    let _redirect = (redirect !== undefined) ? redirect : `/autenticacion?return_to=${location.pathname}${location.search}`;
    let _propsComponent = (propsComponent !== undefined) ?  propsComponent : {};

    return (

      <Route {...rest} render={(props) => {
        if (currentUser.id !== undefined) {
          return (currentUser.authenticated) ? <Component {...props} {..._propsComponent} /> : <Redirect to={_redirect} />
        } else {
          return <Redirect to={_redirect} />;
        }
      }}/>
    );
  }
}
export default withRouter(PrivateRoute);
PrivateRoute.contextType = HomieContext;
